import { BrowserRouter } from 'react-router-dom';

import { Authenticator } from '@aws-amplify/ui-react';
import { Provider } from 'jotai';
import ReactDOM from 'react-dom/client';

import { SessionProvider } from './layouts/SessionContext';

import App from '@/App';
import reportWebVitals from '@/reportWebVitals';

import '@/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider>
    <Authenticator.Provider>
      <SessionProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionProvider>
    </Authenticator.Provider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
